//@flow
export type LocalizationAction =
  | {
      type: 'UPDATE_LOCALE',
      payload: {| locale: string |},
    }
  | {
      type: 'SET_LOCALE',
      payload: {| locale: string |},
    };

export const updateLocale = (locale: string): LocalizationAction => ({
  type: 'UPDATE_LOCALE',
  payload: { locale },
});

export const setLocale = (locale: string): LocalizationAction => ({
  type: 'SET_LOCALE',
  payload: { locale },
});
